export default "__VITE_ASSET__pcNXxp1E__"